module.exports = __webpack_public_path__ + "img/death_prophet.cd385e91.png";